module.exports = __webpack_public_path__ + "static/media/temp_14.45c44a10.jpg";